/**
 * Раскладка колонки превью. Ни одного токена GeoBoost и ни одного цвета: всё цветное
 * приходит из утверждённых глобальных классов (.tgzone, .seg, .lmeter, .micro) в
 * src/styles/base.css. Здесь только геометрия и сброс кнопок — так граница «наш интерфейс /
 * чужой клиент» остаётся ровно там, где её проводит docs/ui-design.md §6.
 */

.panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spacer {
  flex: 1;
}

/* Тумблеры — настоящие кнопки, а не span из макета: переключатель обязан работать
   с клавиатуры и быть виден скринридеру. Внешний вид даёт глобальный .seg-o. */
.segButton {
  font: inherit;
  border: none;
  cursor: pointer;
  background: none;
}

.meter {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Знак вопроса с тултипом про единицы измерения — обязателен по §4.1. */
.hint {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid currentColor;
  font-size: 10px;
  line-height: 1;
  opacity: 0.65;
  cursor: help;
}

/* Действие в плашке карточки — «Перевести в расширенное» (docs/release-2026-09-19.md §9.3).
   Второй ряд плашки, а не кнопка рядом с текстом: строка причины обязана остаться одной
   строкой, а действие — стоять под ней, там, где его ищут глазами после прочтения. */
.lpsAction {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}
